import * as managementGoodsShelfForm from '../services/managementGoodsShelfForm';
import { fmtThousand } from '@/utils/comUtil';

//生成唯一id
function guid() {
  return Number(Math.random().toString().substr(3, 3) + Date.now()).toString(
    36,
  );
}

export default {
  namespace: 'managementGoodsShelfForm',
  state: {
    goodsShelfList: [
      {
        goodsShelfName: '子货架',
        items: {
          title: '',
          subTitle: '',
          gifts: [],
        },
        id: guid(),
      },
    ],
    selectId: '',
    error: 0,
    requireErr: 0,
    isReady: 0,
  },
  effects: {
    *getGiftList({ payload: { values } }, { call, put }) {
      const res = yield call(managementGoodsShelfForm.getGiftList, values);
      yield put({
        type: 'save',
        payload: {
          giftList: res.data,
        },
      });
    },
    *getQueryShelfDetail({ payload: { values } }, { call, put, select }) {
      const res = yield call(
        managementGoodsShelfForm.getQueryShelfDetail,
        values,
      );
      const isReady = yield select(
        (state) => state.managementGoodsShelfForm.isReady,
      );
      const goodsShelfList = res.data.items.map((item) => ({
        goodsShelfName: item.title,
        items: item,
        id: String(item.id),
      }));
      const monthlyExchangeNum = res.data?.monthlyExchangeNum
        ? fmtThousand(res.data.monthlyExchangeNum)
        : res.data?.monthlyExchangeNum;
      const memberThresholdDay = res.data?.memberThresholdDay
        ? fmtThousand(res.data.memberThresholdDay)
        : res.data?.memberThresholdDay;
      const defaultValue = {
        code: res.data?.code,
        description: res.data?.description,
        images: res.data?.images,
        isDefault: String(res.data?.isDefault),
        monthlyExchangeNum: monthlyExchangeNum,
        memberThresholdDay: memberThresholdDay,
        title: res.data?.title,
        memberStartDate: res.data?.memberStartDate,
        memberEndDate: res.data?.memberEndDate,
        sunCode: res.data?.sunCode,
      };
      yield put({
        type: 'save',
        payload: {
          defaultValue,
          goodsShelfList,
          isReady: isReady + 1,
        },
      });
    },
    *saveGoodsShelfDrag({ payload: { values }, callback }, { put, select }) {
      const { items, id } = values;
      const arr = yield select(
        (state) => state.managementGoodsShelfForm.goodsShelfList,
      );
      const newArr = [...arr];
      newArr.forEach((item) => {
        if (item.id === id) {
          item.items.gifts = items;
          return;
        }
      });
      yield put({
        type: 'save',
        payload: {
          goodsShelfList: newArr,
        },
      });
      callback();
    },
    *saveName({ payload: { values } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          goodsShelfList: values.items,
          selectId: values.draggableId,
        },
      });
    },
    *saveId({ payload: { values } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          selectId: values.id,
          error: 0,
          requireErr: 0,
        },
      });
    },
    *addName(_, { put, select }) {
      const arr = yield select(
        (state) => state.managementGoodsShelfForm.goodsShelfList,
      );
      const id = guid();
      arr.push({
        goodsShelfName: '子货架',
        items: {
          title: '',
          subTitle: '',
          gifts: [],
        },
        id,
      });
      yield put({
        type: 'save',
        payload: {
          goodsShelfList: arr,
          error: 0,
          requireErr: 0,
          selectId: id,
        },
      });
    },
    *saveTitle({ payload: { values }, callback }, { put, select }) {
      const { val, id } = values;
      const arr = yield select(
        (state) => state.managementGoodsShelfForm.goodsShelfList,
      );
      const newArr = [...arr];
      newArr.forEach((item) => {
        if (item.id === id) {
          item.items.title = val;
          item.goodsShelfName = val || '子货架';
          return;
        }
      });
      yield put({
        type: 'save',
        payload: {
          goodsShelfList: newArr,
        },
      });
      callback();
    },
    *saveSubTitle({ payload: { values }, callback }, { put, select }) {
      const { val, id } = values;
      const arr = yield select(
        (state) => state.managementGoodsShelfForm.goodsShelfList,
      );
      const newArr = [...arr];
      newArr.forEach((item) => {
        if (item.id === id) {
          item.items.subTitle = val;
          return;
        }
      });
      yield put({
        type: 'save',
        payload: {
          goodsShelfList: newArr,
        },
      });
      callback();
    },
    *saveGoodsShelf({ payload: { values }, callback }, { put, select }) {
      const { chooseList, id } = values;
      const arr = yield select(
        (state) => state.managementGoodsShelfForm.goodsShelfList,
      );
      const newArr = [...arr];
      newArr.forEach((item) => {
        if (item.id === id) {
          item.items.gifts = chooseList;
          return;
        }
      });
      yield put({
        type: 'save',
        payload: {
          goodsShelfList: newArr,
        },
      });
      callback();
    },
    *deleteGoodsShelfGift({ payload: { values }, callback }, { put, select }) {
      const { id, fId } = values;
      const arr = yield select(
        (state) => state.managementGoodsShelfForm.goodsShelfList,
      );
      const newArr = [...arr];
      newArr.forEach((item) => {
        if (item.id === fId) {
          const gifts = item.items.gifts;
          const fGifts = gifts.filter((i) => String(i.id) !== id) || [];
          item.items.gifts = fGifts;
          return;
        }
      });
      yield put({
        type: 'save',
        payload: {
          goodsShelfList: newArr,
        },
      });
      callback();
    },
    *deleteGoodsShelf({ payload: { values }, callback }, { put, select }) {
      const { id } = values;
      const arr = yield select(
        (state) => state.managementGoodsShelfForm.goodsShelfList,
      );
      let newArr = [];
      if (arr.length > 1) {
        newArr = arr.filter((item) => item.id !== id);
      } else {
        newArr = [
          {
            goodsShelfName: '子货架',
            items: {
              title: '',
              subTitle: '',
              gifts: [],
            },
            id: guid(),
          },
        ];
      }
      yield put({
        type: 'save',
        payload: {
          goodsShelfList: newArr,
          selectId: '',
          error: 0,
          requireErr: 0,
        },
      });
      callback();
    },
    *isError({ payload: { values }, callback }, { put, select }) {
      const { id } = values;
      const arr = yield select(
        (state) => state.managementGoodsShelfForm.goodsShelfList,
      );
      const newArr = [...arr];
      let err = 0,
        requireErr = 0;
      newArr.forEach((item) => {
        if (item.id === id) {
          if (!item.items.title) {
            requireErr = 1;
          }
          if (item.items.title.length > 15 && item.items.subTitle.length > 15) {
            err = 1;
          } else if (item.items.title.length > 15) {
            err = 2;
          } else if (item.items.subTitle.length > 15) {
            err = 3;
          }
          return;
        }
      });
      yield put({
        type: 'save',
        payload: {
          error: err,
          requireErr,
        },
      });
      err === 0 && requireErr === 0 && callback();
    },
    *saveForm({ payload: { values }, callback }, { call, select }) {
      const arr = yield select(
        (state) => state.managementGoodsShelfForm.goodsShelfList,
      );
      const newArr = [...arr];
      const paramsArr = [];
      newArr.forEach((item) => {
        item.items.gifts = item.items.gifts.map((i) => ({
          ...i,
          id: Number(i.id),
        }));
        paramsArr.push(item.items);
      });
      const monthlyExchangeNum = values.monthlyExchangeNum
        ? values.monthlyExchangeNum.replace(/,/g, '')
        : values.monthlyExchangeNum;
      const memberThresholdDay = values.memberThresholdDay
        ? values.memberThresholdDay.replace(/,/g, '')
        : values.memberThresholdDay;
      const params = {
        code: values.code,
        description: values.description,
        images: values.images,
        isDefault: Number(values.isDefault),
        items: paramsArr,
        title: values.title,
        monthlyExchangeNum: values.rule ? Number(monthlyExchangeNum) : null,
        memberThresholdDay: values.newMemberRule
          ? Number(memberThresholdDay)
          : null,
        id: values.id,
        memberEndDate: null,
        memberStartDate: null,
      };
      const res = values.id
        ? yield call(managementGoodsShelfForm.updateShelf, params)
        : yield call(managementGoodsShelfForm.addShelf, params);
      callback(res);
    },
    *canDeleteGoodsShelf({ payload: { values }, callback }, { call }) {
      const res = yield call(
        managementGoodsShelfForm.canDeleteGoodsShelf,
        values,
      );
      callback(res);
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        console.log('props.pathname', props.pathname);
        if (
          props.pathname.includes('management_goods_shelf_form_add') ||
          props.pathname.includes('management_goods_shelf_form_edit') ||
          props.pathname.includes('management_goods_shelf_form_detail')
        ) {
          dispatch({
            type: 'save',
            payload: {
              goodsShelfList: [
                {
                  goodsShelfName: '子货架',
                  items: {
                    title: '',
                    subTitle: '',
                    expirationDate: '',
                    gifts: [],
                  },
                  id: guid(),
                },
              ],
              selectId: '',
              error: 0,
              requireErr: 0,
              defaultValue: null,
            },
          });
        }
      });
    },
  },
};
